export const PERFORMANCE_SEARCH_STATUS = 'PERFORMANCE_SEARCH_STATUS';
export const FETCH_DATA = 'FETCH_DATA';
export const SET_SEARCH_STATUS = 'SET_SEARCH_STATUS';
export const RESET_SEARCH_STATUS = 'RESET_SEARCH_STATUS';
export const SET_SEARCH_AGAIN_STATUS = 'SET_SEARCH_AGAIN_STATUS';
